import PageHeader from 'components/global/PageHeader';

const DartmouthLoginTitle = () => {
  return <PageHeader title="Log In to Dartmouth Health Connect" />;
};

export default DartmouthLoginTitle;
